import Language from 'helpers/Language';
let baseURL = '/:lang/builder';
if (process.env.NODE_ENV === 'development') {
	baseURL = '/:lang';
}

const plannerUrl = '/planner/:idSession';
const toolBuildGroup = '/tools/group/:idSession/:idGroup';

const Pages = {
	planner: {
		name: 'Planner',
		url: baseURL + plannerUrl.replace('/:idSession', ''),
		getUrl: () => {
			return Pages.planner.url.replace(':lang', Language.getUrlLanguage());
		}
	},
	plannerWithSession: {
		name: 'Planner with session',
		url: baseURL + plannerUrl,
		getUrl: (id) => {
			return Pages.plannerWithSession.url
				.replace(':idSession', id)
				.replace(':lang', Language.getUrlLanguage());
		}
	},
	sessions: {
		name: 'Sessions',
		url: baseURL + '/sessions',
		getUrl: () => {
			return Pages.sessions.url.replace(':lang', Language.getUrlLanguage());
		}
	},
	toolBuildGroup: {
		name: 'Tool build group',
		url: baseURL + toolBuildGroup,
		getUrl: (idSession, idGroup) => {
			return Pages.toolBuildGroup.url
				.replace(':idSession', idSession)
				.replace(':idGroup', idGroup)
				.replace(':lang', Language.getUrlLanguage());
		}
	}
};
export default Pages;
